<div class="modal-header d-flex align-items-center justify-content-between">
  <div class="modal-title">
    {{ title }}
  </div>
  <div [hidden]="!showClearButton" class="text-link" [class.disabled]="disableClearButton" (click)="clear.emit()">
    Clear
  </div>
</div>
